import Work1 from "../../assets/work1.png"
import Work2 from "../../assets/work2.png"
import Work3 from "../../assets/work3.png"
import Work4 from "../../assets/work4.png"
import Work5 from "../../assets/work5.png"
import Work6 from "../../assets/work6.png"
import Work7 from "../../assets/work7.png"
import Work8 from "../../assets/work8.png"
export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "! Restaurant",
      category: "app",
      link: "https://ifood-lime.vercel.app/",
      github:"https://github.com/boymeetsblockchain/Restaurant-App"
    },
    {
      id: 2,
      image: Work2,
      title: "House Market App",
      category: "web",
      link: "https://house-market-app-eight.vercel.app/",
      github:"https://github.com/boymeetsblockchain/House-Market-App.git"
    },
    {
      id: 3,
      image: Work3,
      title: "Broker site",
      category: "design",
      link: "https://broker-site.vercel.app/",
      github:"https://github.com/boymeetsblockchain/Broker-site"
    },
    {
      id: 4,
      image: Work4,
      title: "ChillFix",
      category: "app",
      link: "https://movies-app-theta-blue.vercel.app/",
      github:"https://github.com/boymeetsblockchain/movies-app"
    },
    {
      id: 5,
      image: Work5,
      title: "Inventory App",
      category: "web",
      link: "https://p-invent.vercel.app/",
      github:"https://github.com/boymeetsblockchain/P-invent-Frontend/tree/master"
    },
    {
      id: 6,
      image: Work6,
      title: "Chat Room",
      category: "web",
      link: "https://chat-room-psi-nine.vercel.app/",
      github:"https://github.com/boymeetsblockchain/chat-room"
    },{
      id: 7,
      image: Work7,
      title: "Hoobank",
      category: "design",
      link: "https://mpi-two.vercel.app/",
      github:"https://github.com/boymeetsblockchain/hoobank"
    },
    {
      id:8,
      image:Work8,
      title:"Support Desk",
      category:"app",
      link:"https://support-desk-awzc.onrender.com/",
      github:"https://github.com/boymeetsblockchain/support-desk.git"
    }
  ];
  
  
  export const projectsNav = [
    {
        name: 'all'
    },
    {
        name: 'web'
    },
    {
        name: 'app'
    },
    {
        name: 'design'
    }
  ]